import { Injector, ProviderToken } from '@angular/core';

export function getFromInjector<T>(token: ProviderToken<T>): T {
  return (<Injector>(<any>window).injector).get(token);
}

export function setInjector(injector: Injector) {
  (<any>window).injector = injector;
}
